import PartnerDetails from "@/wl-core/api/classes/PartnerDetails";

export default class Partner extends PartnerDetails{
    constructor(obj){
        super(obj);
    }

}
